import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    bg: {
      900: '#0A0B0F',
      800: '#101218',
      700: '#161922',
    },
    brand: {
      500: '#6366F1',
      400: '#38BDF8',
      300: '#7DD3FC',
    },
    accent: {
      400: '#FBBF24',
    },
    text: {
      primary: '#F4F6FB',
      muted: '#9AA3B2',
    },
  },
  fonts: {
    heading: "'Space Grotesk', sans-serif",
    body: "'Inter', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  styles: {
    global: {
      body: {
        bg: 'bg.900',
        color: 'text.primary',
        fontFamily: "'Inter', sans-serif",
      },
    },
  },
  components: {
    Button: {
      variants: {
        gold: {
          bg: 'accent.400',
          color: 'bg.900',
          fontFamily: "'Inter', sans-serif",
          fontWeight: '600',
          borderRadius: '8px',
          px: 6,
          py: 3,
          _hover: {
            bg: '#F59E0B',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 24px rgba(251,191,36,0.3)',
          },
          _active: { transform: 'translateY(0)' },
          transition: 'all 0.25s ease',
        },
        outline_brand: {
          bg: 'transparent',
          color: 'text.primary',
          border: '1px solid',
          borderColor: 'whiteAlpha.300',
          fontFamily: "'Inter', sans-serif",
          fontWeight: '500',
          borderRadius: '8px',
          px: 6,
          py: 3,
          _hover: {
            borderColor: 'brand.500',
            color: 'brand.400',
            transform: 'translateY(-2px)',
          },
          _active: { transform: 'translateY(0)' },
          transition: 'all 0.25s ease',
        },
        ghost_brand: {
          bg: 'transparent',
          color: 'text.muted',
          fontFamily: "'Inter', sans-serif",
          fontWeight: '500',
          borderRadius: '8px',
          px: 6,
          py: 3,
          _hover: {
            color: 'brand.400',
            bg: 'transparent',
          },
          _active: { transform: 'translateY(0)' },
          transition: 'all 0.25s ease',
        },
      },
    },
  },
});

export default theme;